import { combineReducers } from 'redux';
import { assignAssetModalReducer } from './modal/store/assignAssetModal.reducer';
import { assetsFiltersReducer } from './store/machineMaintenanceAssets.reducer';

export const machineMaintenanceAssetsReducer = combineReducers({
    assignAssetModal: assignAssetModalReducer,
    filters: assetsFiltersReducer,
});
